module.exports = __webpack_public_path__ + "img/vip2.d066f4cd.png";